module.exports = __webpack_public_path__ + "media/audio3.ce1a1e55.mp3";